import script from "./FaceApiAction.vue?vue&type=script&setup=true&lang=js"
export * from "./FaceApiAction.vue?vue&type=script&setup=true&lang=js"

import "./FaceApiAction.vue?vue&type=style&index=0&id=2d4835af&lang=scss"

const __exports__ = script;

export default __exports__